import Footer from './Footer';
import Failed from '../../../../assets/images/failed-payment.svg';
import {TransactionResponse} from '../api';

const PaymentFailure: React.FC<{
  transactionResponse: TransactionResponse | null;
}> = ({transactionResponse}) => {
  return (
    <div className="flex flex-col w-full justify-center">
      <div className="flex flex-col items-center justify-center py-16">
        <img src={Failed} alt="Failed" className="w-fit h-fit mb-8" />

        <h2 className="text-[28px]  text-displayBlack font-semibold mb-[3px]">
          Payment Failed!
        </h2>
        <p className=" text-secondaryGrayscale font-normal text-sm text-center">
          Something went wrong😔!
          <br />
          Reason for failure:{' '}
          {transactionResponse?.transaction?.status || 'Unknown error'}.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentFailure;
